module.exports = __webpack_public_path__ + "static/media/30.deb8176f.png";